<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <div class="col-md-12">
      <!-- <div style="text-align: left" class="p-3 mb-2 bg-secondary text-white">
        <b> Doctor Profile:</b>
      </div> -->
     
      <div class="col-12" style="margin-top:4px;">
        <h5> Profile 
          <b-button class="float-right" variant="danger" @click="handleBack">
          <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>Back</b-button
        >
        </h5>
        <hr/>
        
      </div>
       <b-card>
      <form>
        <form action="/action_page.php">
          <table>
          <tr>
            <td width="45%" style="text-align: left">Name</td>
            <td width="1%" style="text-align:left">:</td>
            <td width="54%" style="text-align:left">
            <input type="text" id="Tname" name="Tname" >
            </td>
          </tr>
          <tr>
            <td width="45%" style="text-align: left">Degree</td>
            <td width="1%" style="text-align:left">:</td>
            <td width="54%" style="text-align:left">
            <input type="text" id="Tname" name="Tname" > </td>
          </tr>
          <tr>
            <td width="45%" style="text-align: left">Address</td>
            <td width="1%" style="text-align:left">:</td>
            <td width="54%" style="text-align:left">
            <input type="text" id="Tname" name="Tname"  > </td>
          </tr>
          <tr>
            <td width="45%" style="text-align: left">Contact</td>
            <td width="1%" style="text-align:left">:</td>
            <td width="54%" style="text-align:left">
            <input type="text" id="Tname" name="Tname"  > </td>
          </tr>
          <tr>
            <td width="45%" style="text-align: left">Experience</td>
            <td width="1%" style="text-align:left">:</td>
            <td width="54%" style="text-align:left">
            <input type="text" id="Tname" name="Tname"  > </td>
          </tr>
         
         

         
         

         
          </table>
        </form>
      </form>
      <br/>
    
    <center>  <b-button  variant="primary" @click="handleSubmit2">Update</b-button>&nbsp;
       <b-button  variant="primary" @click="handleSubmit2">Reset</b-button>
      <br/><hr/>
      <!-- <b-button  variant="primary" @click="handleSubmit4">Reset</b-button>&nbsp; -->
      <b-button style="text-align: right" variant="success" @click="handleSubmit3"> 
         <router-link
                          style="color: white"
                          :to="{ name: 'change_password' }"
                          >Change Password</router-link
                        >
      </b-button></center>
     </b-card>
       <!-- <b-button  variant="danger" @click="handleBack">Back</b-button> -->
    </div>
  </div>
  </div>
</template>

<script>
import * as _ from "lodash";

//import ApplicationFilter from "../components/ApplicationFilter.vue";
//import MarksEntry from "../components/MarksEntry.vue";
//alert(1);
export default {
  methods: {
    handleSubmit2() {
      alert("update Success");
    },
    // handleSubmit3() {
    //   alert("password change succesfully");
    // },
    handleSubmit4() {
      alert("Reset all data");
    },
    handleBack(){
            this.$router.go(-1);
        },
    reset_details() {
      this.Observations = "";
    },
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;

  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
